import {w} from './cltvo/constants';
export const menuBanner = function () {
    if( w.width() <= 992 ){
        $('#header-mobile_JS').css({top: '63px'});
        w.on('scroll', () => {
            if( w.scrollTop() >= 5 ){
                $('#header-mobile_JS').css({top: '0px'});
            }else{
                $('#header-mobile_JS').css({top: '63px'});
            }
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/menu-banner.js